import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'adminlte';
  ngAfterViewChecked() {
    //document.querySelector<HTMLElement>('.p-divider-horizontal').style.backgroundColor = '#f16e00';
    

  }
  ngAfterViewInit() {
    //document.querySelectorAll("app-root").forEach(i => (<HTMLElement>i).className = "hold-transition sidebar-mini sidebar-collapse");
    
  } 
  
}
